// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimProposalDTO } from '../models';
/**
 * ClaimProposalsApi - axios parameter creator
 * @export
 */
export const ClaimProposalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Agree to a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeClaimProposal(claimId: string, claimProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling agreeClaimProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling agreeClaimProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/agree`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Counter a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterClaimProposal(claimId: string, claimProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling counterClaimProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling counterClaimProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/counter`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Dispute a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeClaimProposal(claimId: string, claimProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling disputeClaimProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling disputeClaimProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/dispute`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a draft claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaimProposal(claimId: string, claimProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling publishClaimProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling publishClaimProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/publish`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Unpublish a previously published but unpaid claim proposal from a Tenant
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishClaimProposal(claimId: string, claimProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling unpublishClaimProposal.');
            }
            // verify required parameter 'claimProposalId' is not null or undefined
            if (claimProposalId === null || claimProposalId === undefined) {
                throw new RequiredError('claimProposalId','Required parameter claimProposalId was null or undefined when calling unpublishClaimProposal.');
            }
            const localVarPath = `/v2/claims/{claimId}/proposals/{claimProposalId}/unpublish`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimProposalId"}}`, encodeURIComponent(String(claimProposalId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimProposalsApi - functional programming interface
 * @export
 */
export const ClaimProposalsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Agree to a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeClaimProposal(claimId: string, claimProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProposalDTO> {
            const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).agreeClaimProposal(claimId, claimProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Counter a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterClaimProposal(claimId: string, claimProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProposalDTO> {
            const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).counterClaimProposal(claimId, claimProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Dispute a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeClaimProposal(claimId: string, claimProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProposalDTO> {
            const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).disputeClaimProposal(claimId, claimProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Publish a draft claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaimProposal(claimId: string, claimProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProposalDTO> {
            const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).publishClaimProposal(claimId, claimProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unpublish a previously published but unpaid claim proposal from a Tenant
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishClaimProposal(claimId: string, claimProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProposalDTO> {
            const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).unpublishClaimProposal(claimId, claimProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimProposalsApi - factory interface
 * @export
 */
export const ClaimProposalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Agree to a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeClaimProposal(claimId: string, claimProposalId: string, options?: any) {
            return ClaimProposalsApiFp(configuration).agreeClaimProposal(claimId, claimProposalId, options)(axios, basePath);
        },
        /**
         * Counter a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterClaimProposal(claimId: string, claimProposalId: string, options?: any) {
            return ClaimProposalsApiFp(configuration).counterClaimProposal(claimId, claimProposalId, options)(axios, basePath);
        },
        /**
         * Dispute a claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeClaimProposal(claimId: string, claimProposalId: string, options?: any) {
            return ClaimProposalsApiFp(configuration).disputeClaimProposal(claimId, claimProposalId, options)(axios, basePath);
        },
        /**
         * Publish a draft claim proposal
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaimProposal(claimId: string, claimProposalId: string, options?: any) {
            return ClaimProposalsApiFp(configuration).publishClaimProposal(claimId, claimProposalId, options)(axios, basePath);
        },
        /**
         * Unpublish a previously published but unpaid claim proposal from a Tenant
         * @param {string} claimId Claim id
         * @param {string} claimProposalId Claim proposal id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishClaimProposal(claimId: string, claimProposalId: string, options?: any) {
            return ClaimProposalsApiFp(configuration).unpublishClaimProposal(claimId, claimProposalId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimProposalsApi - interface
 * @export
 * @interface ClaimProposalsApi
 */
export interface ClaimProposalsApiInterface {
    /**
     * Agree to a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApiInterface
     */
    agreeClaimProposal(claimId: string, claimProposalId: string, options?: any): AxiosPromise<ClaimProposalDTO>;

    /**
     * Counter a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApiInterface
     */
    counterClaimProposal(claimId: string, claimProposalId: string, options?: any): AxiosPromise<ClaimProposalDTO>;

    /**
     * Dispute a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApiInterface
     */
    disputeClaimProposal(claimId: string, claimProposalId: string, options?: any): AxiosPromise<ClaimProposalDTO>;

    /**
     * Publish a draft claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApiInterface
     */
    publishClaimProposal(claimId: string, claimProposalId: string, options?: any): AxiosPromise<ClaimProposalDTO>;

    /**
     * Unpublish a previously published but unpaid claim proposal from a Tenant
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApiInterface
     */
    unpublishClaimProposal(claimId: string, claimProposalId: string, options?: any): AxiosPromise<ClaimProposalDTO>;

}

/**
 * ClaimProposalsApi - object-oriented interface
 * @export
 * @class ClaimProposalsApi
 * @extends {BaseAPI}
 */
export class ClaimProposalsApi extends BaseAPI implements ClaimProposalsApiInterface {
    /**
     * Agree to a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApi
     */
    public agreeClaimProposal(claimId: string, claimProposalId: string, options?: any) {
        return ClaimProposalsApiFp(this.configuration).agreeClaimProposal(claimId, claimProposalId, options)(this.axios, this.basePath);
    }

    /**
     * Counter a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApi
     */
    public counterClaimProposal(claimId: string, claimProposalId: string, options?: any) {
        return ClaimProposalsApiFp(this.configuration).counterClaimProposal(claimId, claimProposalId, options)(this.axios, this.basePath);
    }

    /**
     * Dispute a claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApi
     */
    public disputeClaimProposal(claimId: string, claimProposalId: string, options?: any) {
        return ClaimProposalsApiFp(this.configuration).disputeClaimProposal(claimId, claimProposalId, options)(this.axios, this.basePath);
    }

    /**
     * Publish a draft claim proposal
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApi
     */
    public publishClaimProposal(claimId: string, claimProposalId: string, options?: any) {
        return ClaimProposalsApiFp(this.configuration).publishClaimProposal(claimId, claimProposalId, options)(this.axios, this.basePath);
    }

    /**
     * Unpublish a previously published but unpaid claim proposal from a Tenant
     * @param {string} claimId Claim id
     * @param {string} claimProposalId Claim proposal id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProposalsApi
     */
    public unpublishClaimProposal(claimId: string, claimProposalId: string, options?: any) {
        return ClaimProposalsApiFp(this.configuration).unpublishClaimProposal(claimId, claimProposalId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimProposalsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Agree to a claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function agreeClaimProposal(
    claimId: string,
    claimProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimProposalDTO> {
    const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).agreeClaimProposal(claimId, claimProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Counter a claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function counterClaimProposal(
    claimId: string,
    claimProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimProposalDTO> {
    const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).counterClaimProposal(claimId, claimProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Dispute a claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function disputeClaimProposal(
    claimId: string,
    claimProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimProposalDTO> {
    const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).disputeClaimProposal(claimId, claimProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Publish a draft claim proposal
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function publishClaimProposal(
    claimId: string,
    claimProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimProposalDTO> {
    const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).publishClaimProposal(claimId, claimProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Unpublish a previously published but unpaid claim proposal from a Tenant
 * @param {string} claimId Claim id
 * @param {string} claimProposalId Claim proposal id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function unpublishClaimProposal(
    claimId: string,
    claimProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimProposalDTO> {
    const localVarAxiosArgs = ClaimProposalsApiAxiosParamCreator(configuration).unpublishClaimProposal(claimId, claimProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

